import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { trackingAPI, publicAPI } from '@/lib/api';
import { hasTrackingConsent } from '@/components/CookieConsent';

export default function GoRedirect() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(false);

  useEffect(() => {
    const trackAndRedirect = async () => {
      try {
        if (hasTrackingConsent()) {
          const res = await trackingAPI.trackClick({
            source: searchParams.get('source') || 'website',
            traffic_source: searchParams.get('traffic_source') || searchParams.get('source') || 'website',
            utm_source: searchParams.get('utm_source'),
            utm_medium: searchParams.get('utm_medium'),
            utm_campaign: searchParams.get('utm_campaign'),
            referrer: document.referrer,
            browser: navigator.userAgent,
            device: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            os: navigator.platform,
            session_id: sessionStorage.getItem('session_id') || (() => {
              const id = crypto.randomUUID?.() || Math.random().toString(36).substr(2);
              sessionStorage.setItem('session_id', id);
              return id;
            })(),
          });
          const redirectUrl = res.data?.redirect_url;
          if (redirectUrl) { window.location.href = redirectUrl; return; }
        }
        // No consent or tracking failed: redirect without tracking
        const settings = await publicAPI.getSettings();
        const url = settings.data?.affiliate_url;
        if (url) { window.location.href = url; return; }
        setError(true);
      } catch (err) {
        console.error('Redirect failed:', err);
        try {
          const settings = await publicAPI.getSettings();
          if (settings.data?.affiliate_url) { window.location.href = settings.data.affiliate_url; return; }
        } catch {}
        setError(true);
      }
    };
    trackAndRedirect();
  }, [searchParams]);

  if (error) {
    return (
      <div data-testid="go-redirect-error" className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center max-w-md px-4">
          <p className="text-slate-800 font-body font-medium mb-2">Weiterleitung fehlgeschlagen</p>
          <p className="text-slate-500 font-body text-sm mb-4">
            Die Buchungsseite konnte nicht geladen werden.
          </p>
          <a href="/" className="text-[#0E518D] underline font-body text-sm">
            Zurück zur Startseite
          </a>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="go-redirect-page" className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0E518D] mx-auto mb-4" />
        <p className="text-slate-600 font-body text-sm">Sie werden zur Buchungsseite weitergeleitet...</p>
      </div>
    </div>
  );
}
